import Vue from 'vue';
import route from '@H/route';
import codes from '@H/codes';
import axios from 'axios';
import availableLanguages from './availableLanguages';
import { detect } from 'detect-browser';
import { mapGetters } from 'vuex';

Vue.mixin({
    created: function() {
        this.$browser = detect();
        this.$laraRoute = route;
        this.$axios = axios;
        this.$codes = codes(availableLanguages);
    },
    mounted() {
        this.disableInputs();
    },
    computed: {
        ...mapGetters(['autocompleteSettings'])
    },
    methods: {
        disableInputs() {
            const inputs = document.querySelectorAll('input[autocomplete]')
            if (inputs.length) {
                inputs.forEach(input => {
                    if (input.type !== 'password' && input.type !== 'email') {
                        input.setAttribute('autocomplete', this.autocompleteSettings);
                    } else {
                        input.setAttribute('autocomplete', 'on');
                    }
                })
            }
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/setup/mixins.js